import { DeviceStatusEnum } from '@app/api/equipment/dtos';

export enum ImGroupMemberTypeEnum {
  PU = 'PU',
  User = 'User',
}

export interface ImGroupMemberPermissionDto {
  id?: 'master' | 'manager';
  level?: number;
}

export interface ImGroupMemberDto {
  id: number;
  memberID: string;
  memberType: ImGroupMemberTypeEnum;
  memberName: string;
  name?: string;
  permissions: ImGroupMemberPermissionDto[];
  status?: DeviceStatusEnum;
}
